<template>
  <div>
    <b-modal ref="view-image-modal" hide-footer centered>
      <img class="rounded image" alt="image" :src="this.img">
      <p v-if="name" class="mt-2 mb-2 font-italic welcome-text"><b>{{name}}</b></p>
      <p v-if="description" class="mt-2 mb-2 font-italic welcome-text">{{description}}</p>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ViewImage",
  data(){
    return {
      img: '',
      name: '',
      description: ''
    }
  },
  methods: {
    showModal(img, name='', description='') {
      this.img = img
      this.description = description
      this.name = name
      this.$refs['view-image-modal'].show()
    },
    hideModal() {
      this.$refs['view-image-modal'].hide()
    },
  }
}
</script>

<style scoped>
.image{
  width: 100%;
  height: auto;
}
.modal-header{
  border-bottom: none;
}
.welcome-text{
  color: #392A20;
}
</style>



// WEBPACK FOOTER //
// src/components/ViewImage.vue